var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReferClean(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 4.1625C8.71563 6.34163 9.29333 10.0429 11.5852 14.3156C12.6204 16.2416 12.361 17.7131 11.9614 18.6075C10.8684 21.0578 7.87079 21.7564 4.69847 22.4955C2.51235 23.0063 2.65148 23.4743 2.65148 27H0.430858L0.425293 25.6039C0.425293 22.7689 0.646799 21.132 3.96271 20.358C7.70828 19.4839 11.4071 18.7009 9.62837 15.3878C4.36009 5.56763 8.12569 0 13.7824 0C17.479 0 20.4276 2.38162 20.4276 6.93787C20.4276 10.9373 18.2582 14.625 17.7751 15.75H15.4209C15.8573 14.022 18.2025 10.8383 18.2025 6.92775C18.2025 1.13063 11.672 1.31963 10.0001 4.1625ZM24.9134 21.375H21.5741V18H19.3479V21.375H16.0086V23.625H19.3479V27H21.5741V23.625H24.9134V21.375Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferClean);
export default __webpack_public_path__ + "static/media/refer_clean.0fb70484435aff60ca9499e90eae7f16.svg";
export { ForwardRef as ReactComponent };